import axios from 'axios'
import qs from 'qs'
import emitter from '@/utils/emitter'
import CODE from '@shared/constants/code'
import { SERVERS, HOST_ENV } from '@/constants/environment'

const CancelToken = axios.CancelToken
// http config
const TIMEOUT_TIME = 30000
// const THRESHOLD_TIME = 500
const SUCCESS_CODE = 0

axios.defaults.timeout = TIMEOUT_TIME
axios.defaults.crossOrigin = true
axios.defaults.withCredentials = true

axios.defaults.baseURL = process.env.NODE_ENV === 'production' && HOST_ENV !== 'ames' ? '/api' : `${SERVERS.CRM}/api`

axios.interceptors.request.use(
  (config) => config,
  (err) => {
    return Promise.reject(err)
  },
)

axios.interceptors.response.use((response) => {
  if (process.env.NODE_ENV !== 'development' && HOST_ENV !== 'ames') {
    const $a = document.createElement('a')
    $a.setAttribute('href', response.request.responseURL)

    if ($a.hostname !== location.hostname) {
      return response
    }
  }

  const globalErrorCodes = Object.values(CODE).filter((code) => ![CODE.SUCCESS, CODE.FAIL].includes(code))

  if (globalErrorCodes.includes(response.data.code)) {
    emitter.$emit('http.code.exception', response.data.code)

    return Promise.reject(
      createError(
        'custom exception ' + response.data.code,
        response.config,
        response.data.code,
        response.request,
        response,
      ),
    )
  } else {
    return response
  }
})

axios.interceptors.response.use(null, (error) => {
  if (window.Sentry && !(axios.isCancel(error) || error.message.startsWith('custom exception'))) {
    try {
      window.Sentry.withScope((scope) => {
        scope.setExtra('details', {
          message: error.message,
          config: error.config,
          code: error.code,
          request: error.request,
          response: error.response,
        })
        window.Sentry.captureMessage(error.message)
      })
    } catch (e) {
      window.Sentry.withScope((scope) => {
        scope.setExtra('details', e)
        window.Sentry.captureMessage('catch request error parser')
      })
    }
  }

  // error.response 几乎为 undefined
  return Promise.reject(error)
})

const request = (method) => (url) => {
  const promise = (data = {}, config, catcher = true) =>
    new Promise((resolve, rejects) =>
      axios({
        url,
        method,
        params: method === 'get' ? data : null,
        data: method === 'post' ? qs.stringify(data) : null,
        cancelToken: new CancelToken((c) => (promise.abort = c)),
        ...config,
      })
        .then(({ data }) => {
          if (catcher && data.code !== SUCCESS_CODE) {
            emitter.$emit('http.exception-message', data.msg)

            rejects({
              status: 'exception',
              payload: data,
            })
          } else {
            resolve(data)
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            rejects({
              status: 'canceled',
              payload: {
                url,
                msg: error.message,
              },
            })
          } else if (error.message.startsWith('custom exception')) {
            rejects(error)
          } else {
            rejects({
              status: 'network',
              payload: {
                msg: 'Network Error',
              },
            })
          }
        }),
    )

  return promise
}

export const get = request('get')
export const post = request('post')

// 防 axios 错误格式
function createError(message, config, code, request, response) {
  const error = new Error(message)
  return enhanceError(error, config, code, request, response)
}

function enhanceError(error, config, code, request, response) {
  error.config = config
  if (code) {
    error.code = code
  }
  error.request = request
  error.response = response
  return error
}
